import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import "./dados_consultoria.css";

class DadosConsultoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noColorDiv: "data",
      activeContainerStyle: null
    };
  }

  handleStyleContainer(value) {
    switch (value) {
      case null:
        return this.setState({ activeContainerStyle: this.state.noColorDiv });
      case 1:
        return this.setState({
          activeContainerStyle: `${this.state.noColorDiv} color-data-container`
        });
    }
  }

  componentDidMount() {
    let component = this.props.component ? this.props.component : null;
    this.handleStyleContainer(component);
  }

  render() {
    return (
      <section className={this.state.activeContainerStyle}>
        <Row>
          <Col xs="12" lg="4" className="data-item">
            <Col className="data-number justify-content-center d-flex">0</Col>
            <Col className="data-text justify-content-center d-flex">
              Médicos cadastrados
            </Col>
          </Col>
          <Col xs="12" lg="4" className="data-item">
            <Col className="data-number justify-content-center d-flex">0</Col>
            <Col className="data-text justify-content-center d-flex">
              Clientes satisfeitos
            </Col>
          </Col>
          <Col xs="12" lg="4" className="data-item">
            <Col className="data-number justify-content-center d-flex">0</Col>
            <Col className="data-text justify-content-center d-flex">
              Médicos online agora
            </Col>
          </Col>
        </Row>
      </section>
    );
  }
}

export default DadosConsultoria;
